export function setRefererUrl(url: string) {
  localStorage.setItem('_ref', url);
}
